import CurrentUser from './CurrentUser'

export default CurrentUser
